/** Welcome screen copy — daily tip per agent (stable for the calendar day). */

const TZ = 'Asia/Colombo';

const TERMINAL_TIPS = [
  'Type help for every command · ig returns to the menu from any flow.',
  'Use /mine to see only your open inquiries, or combine /tickets /text name.',
  'After a search, pick 1 for terminal results or 2 for the full leads page.',
  'Press ↑ ↓ in the input to recall recent commands.',
  'Ctrl+; inserts now as YYYY:MM:DD HH:MM · Ctrl+Shift+; inserts date only.',
  'On an open inquiry: edit · call · pricing · history · collect balance (tours).',
  'Optional fields accept skip or - to leave blank.',
  'Type stats anytime for your month numbers.',
];

const TRAVEL_TIPS = [
  'Always confirm passport validity (6+ months) before quoting visa processing time.',
  'For India eVisa, capture purpose (tourist/business) and duration (30d/1y) in the inquiry.',
  'Quote tour packages with clear 4N5D style duration so ops knows nights vs days.',
  'When a client gives a phone number, log the call in the inquiry — it helps follow-ups.',
  'Direct flights sell easier — note seat and baggage prefs on ticket inquiries early.',
  'If balance is due on a tour, use collect balance in the terminal after payment.',
  'Malaysia and Vietnam eVisas usually need a clear scan of the bio page — remind clients.',
  'Weekend departures: double-check airline cut-off times before confirming PNR.',
  'Student (STU) fares need valid student proof — flag it in notes for ticketing.',
  'Dubai transit under 8 hours may not need a visa — verify routing before promising.',
];

function dayKey(date = new Date()) {
  return date.toLocaleDateString('en-CA', { timeZone: TZ });
}

function hashSeed(str) {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = ((h << 5) - h) + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

/** One tip per agent per calendar day (Colombo). */
export function pickDailyTip(agentId, agentName = '') {
  const seed = `${dayKey()}:${agentId || agentName || 'agent'}`;
  const pool = [...TERMINAL_TIPS, ...TRAVEL_TIPS];
  return pool[hashSeed(seed) % pool.length];
}

function greetingForHour(date = new Date()) {
  const hour = Number(date.toLocaleString('en-GB', { timeZone: TZ, hour: 'numeric', hour12: false }));
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

export function formatWelcomeHtml({ agentName, tip, timeLabel, statsLine }) {
  const name = agentName ? `, ${escapeHtml(agentName)}` : '';
  const tipHtml = tip ? `<div class="assistant-welcome-tip"><span class="assistant-welcome-tip-label">Tip</span>${escapeHtml(tip)}</div>` : '';
  const statsHtml = statsLine
    ? `<div class="assistant-welcome-stats">${escapeHtml(statsLine)}</div>`
    : '';
  return [
    `<div class="assistant-welcome-card">`,
    `<div class="assistant-welcome-greet">${escapeHtml(greetingForHour())}${name}</div>`,
    timeLabel ? `<div class="assistant-welcome-time">${escapeHtml(timeLabel)}</div>` : '',
    tipHtml,
    statsHtml,
    `<div class="assistant-welcome-actions">new ticket · new visa · new tour · search · help</div>`,
    `</div>`,
  ].join('');
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function formatBootStatsLine(stats) {
  if (!stats) return null;
  const mc = stats.month_completed || {};
  const parts = [
    `Month done: ${mc.ticket || 0} tickets · ${mc.visa || 0} visa · ${mc.tour || 0} tours`,
  ];
  if (stats.total != null) parts.push(`${stats.total} active`);
  if (stats.overdue) parts.push(`${stats.overdue} overdue`);
  return parts.join(' · ');
}
